// ⋯ → Change status manually. The override: any status, reason required
// (by this dialog), logged as a 'manual' event by PATCH /orders/:id.
import React, { useState } from 'react';
import axios from '../../lib/axiosClient';
import { UI, STATUSES, STATUS_LABEL, useIsNarrow } from './pipeline';

export default function ManualStatusDialog({ order, onClose, onDone, showFlash }) {
  const narrow = useIsNarrow();
  const [status, setStatus] = useState(order.status);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const canSave = status !== order.status && reason.trim().length > 0 && !busy;

  async function save() {
    setBusy(true); setErr(null);
    try {
      await axios.patch(`/api/rentals/orders/${order.id}`, { status, reason: reason.trim() });
      onDone();
    } catch (e) {
      const d = e.response?.data || {};
      setErr(d.error || 'Failed'); setBusy(false);
      showFlash?.(d.error || 'Failed', 'error');
    }
  }

  return (
    <div style={UI.overlay(narrow)} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={UI.box(narrow, 420)} data-testid="manual-status-dialog" role="dialog">
        <div style={UI.head}>
          <div><div style={UI.title}>Change status manually</div><div style={UI.sub}>{order.order_number || '#' + order.id} · {order.client_name} · use the primary button for normal moves</div></div>
          <button style={UI.close} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div style={UI.body}>
          <label style={{ ...UI.lbl, marginTop: 0 }}>New status</label>
          <select data-testid="manual-status" value={status} onChange={e => setStatus(e.target.value)} style={UI.inp}>
            {STATUSES.map(s => <option key={s} value={s}>{STATUS_LABEL[s]}{s === order.status ? ' (current)' : ''}</option>)}
          </select>
          <label style={UI.lbl}>Reason <span style={{ color: '#f87171' }}>*</span></label>
          <textarea data-testid="manual-reason" value={reason} onChange={e => setReason(e.target.value)} placeholder="Why this order is moved out of sequence" style={{ ...UI.inp, height: 70, resize: 'vertical' }} />
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>Logged on the order with your login. Moving to Reserved re-checks availability; moving from Out frees the units.</div>
          {err && <div style={{ marginTop: 10, color: '#f87171', fontSize: 12 }} data-testid="dialog-error">{err}</div>}
        </div>
        <div style={UI.foot}>
          <button style={UI.cancelBtn} onClick={onClose}>Back</button>
          <button data-testid="manual-save" disabled={!canSave} onClick={save} style={UI.goBtn(canSave, '#2e3150', '#e2e8f0')}>{busy ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}
